export default {
	path: '/retrieveByMobile',
	getComponent(nextState, cb) {
		require.ensure(
			[],
			(require) => {
				cb(null, require('../../pc/retrieve/RetrieveByMobile.js').default)
			},
			'retrieve-by-mobile'
		)
	},
}



// WEBPACK FOOTER //
// ./src/routes/retrieve/retrieveByMobile.js